import React from "react";
import { Modal, Button } from "react-bootstrap";
import ModalBase from '../modals/ModalBase';
import DropAndCrop from "./DropAndCrop";

import '../../../assets/sass/components/images/drop-and-crop-modal.scss';

class DropAndCropModal extends ModalBase {
    constructor(props) {
        super(props)
    
        this.state = {
            image: props.image
        }
    }

    static defaultProps = {
        ...super.defaultProps,
        size: "md",
        headerTitle: 'Change Profile Photo',
        btnText: 'Set Profile Photo',
        image: '',
        dropProps: {},
        cropProps: {},
        onSubmit: () => console.log('submitted'),
    };
    
    renderBody = () => {
        var {dropProps, cropProps} = this.props;
        return (
            <DropAndCrop img={this.props.image} onCrop={this.handleImage} dropProps={{...dropProps}} cropProps={{...cropProps}} />
        )
    };

    renderHeader = () => {
        const { headerTitle } = this.props;

        return (
            <React.Fragment>
                <Modal.Title className="title">{headerTitle}</Modal.Title>
            </React.Fragment>
        );
    };

    renderFooter = () => {
        const { btnText, onSubmit } = this.props;
        const { image } = this.state;

        const isDisabled = !image;

        return (
            <Button
                variant="primary"
                className="lg"
                disabled={isDisabled}
                onClick={() => onSubmit(image)}
            >{btnText}</Button>
        )
    }

    handleImage = (croppedImage) => {
        this.setState({ image: croppedImage });
    }

    modalClassname = () => "drop-and-crop-modal";
}

export default DropAndCropModal;
